import { render, staticRenderFns } from "./UcCompanyPanel.yaml?vue&type=template&id=274ac0cc&component"
import script from "./UcCompanyPanel.yaml?vue&type=script&lang=ts&component"
export * from "./UcCompanyPanel.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports